import {Injectable} from '@angular/core';
import {BaseRequestService} from './base-request.service';
import {Observable} from 'rxjs';
import {KioskBean, PageBean, ResponseBean, StepSequenceTestBean, StepSequenceTestResultBean} from '../model/model';

@Injectable()
export class StepTestService extends BaseRequestService {

    getTests(kioskId: number, operatorId: number, limit?: number, offset?: number): Observable<PageBean<StepSequenceTestBean>> {
        return this.get('admin/tests/kiosk/' + kioskId + '/location/' + operatorId + '/list',
            BaseRequestService.buildOffsetParams(limit, offset));
    }

    addTest(kioskId: number, operatorId: number, test: StepSequenceTestBean): Observable<ResponseBean> {
        return this.post('admin/tests/kiosk/' + kioskId + '/location/' + operatorId + '/add_test', test);
    }

    deleteTest(kioskId: number, operatorId: number, test: StepSequenceTestBean): Observable<ResponseBean> {
        return this.del('admin/tests/kiosk/' + kioskId + '/location/' + operatorId + '/test/' + test.id + '/delete');
    }

    getTestResults(kioskId: number, operatorId: number, test: StepSequenceTestBean, limit?: number, offset?: number):
        Observable<PageBean<StepSequenceTestResultBean>> {
        return this.get('admin/tests/kiosk/' + kioskId + '/location/' + operatorId + '/test/' + test.id + '/results',
            BaseRequestService.buildOffsetParams(limit, offset));
    }
}
